module.exports = __webpack_public_path__ + "static/ProximaNova-Regular-d900267b81d84f291cc3736943e949f3.woff";